export default "__VITE_ASSET__b714b3df__"